if ( typeof ProductPage !== 'function' ) {

  class ProductPage extends HTMLElement {

    constructor(){

      super();

      this.productGallery = this.querySelector('[data-js-product-gallery]');
      this.productSlider = this.querySelector('css-slider');

      // Gallery thumbnails

      if ( this.productSlider ) {

        const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

        if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

          this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
            if ( i === 0 ) {
              elm.classList.add('active');
            }

            elm.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();

              const index = parseInt(elm.dataset.index);

              // Gérer les thumbnails actifs
              this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach(t => {
                t.classList.remove('active');
              });
              elm.classList.add('active');

              if ( this.productSlider.sliderEnabled ) {
                this.productSlider.changeSlide(index);
              } else {
                const target = this.productGallery.querySelector(`.product-gallery-item[data-index="${index}"]`);
                if (target) {
                  target.scrollIntoView({ behavior: 'smooth' });
                }
                this.thumbnailNavigationHelper(index);
              }

              if (productGaleryThumbnails) {
                productGaleryThumbnails.scrollTo({
                  left: elm.offsetLeft - 50,
                  behavior: 'smooth'
                });
              }
            });
          });

          this.productSlider.addEventListener('change', e => {
            this.thumbnailNavigationHelper(parseInt(e.target.index));
          });

        }

        this.productSlider.addEventListener('change', e => {
          const currentItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
          if (currentItem && currentItem.dataset.productMediaType === 'model') {
            if (this.xrButton) {
              this.xrButton.setAttribute('data-shopify-model3d-id', currentItem.dataset.mediaId);
            }
            setTimeout(() => {
              const holder = this.productSlider.querySelector('.css-slider-holder');
              if (holder) {
                holder.classList.add('css-slider--disable-dragging');
              }
            }, 150);
          }
        });

        // Parallax

        this.productSlider.addEventListener('ready', (e) => {
          if ( this.firstProductGalleryIndex ) {
            this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
          }

          const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
          const productFigures = this.querySelectorAll('.apply-gallery-animation');
          this.productSlider.addEventListener('scroll', () => {
            const scrollX = -this.productSlider.element.scrollLeft;
            productSlides.forEach((slide, i) => {
              const media = productFigures[i];
              if ( media ) {
                media.style.transform = `translateX(${(slide.offsetLeft + scrollX) * -1 / 3}px)`;
              }
            });
          });
        });
      }

      // show cart drawer when element is added to cart

      if ( !document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action === 'overlay' || KROWN.settings.cart_action === 'popup' ) ) {

        let addToCartEnter = false;

        const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
        const productForm = this.querySelector('[data-js-product-form]');

        if ( addToCartButton ) {
          addToCartButton.addEventListener('keyup', e => {
            if ( e.keyCode === window.KEYCODES.RETURN ) {
              addToCartEnter = true;
              window.lastFocusedElm = addToCartButton;
            }
          });
        }

        if ( productForm ) {
          productForm.addEventListener('add-to-cart', () => {
            document.getElementById('site-cart-sidebar')?.show();
            document.getElementById('cart-recommendations')?.generateRecommendations();

            if ( addToCartEnter ) {
              setTimeout(() => {
                document.querySelector('#site-cart-sidebar [data-js-close]')?.focus();
                addToCartEnter = false;
              }, 200);
            }
          });
        }
      }

      // Check for models

      const models = this.querySelectorAll('product-model');
      if ( models.length > 0 ) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector('.product-gallery__view-in-space');
      }

      // hide buy now button if stock disabled

      const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
      if ( addToCartButton ) {
        const form = this.querySelector('product-form');
        if ( addToCartButton.classList.contains('disabled') ) {
          form?.classList.add('disable-buy-button');
        } else {
          form?.classList.remove('disable-buy-button');
        }
        const buyObserver = new MutationObserver(() => {
          if ( addToCartButton.classList.contains('disabled') ) {
            form?.classList.add('disable-buy-button');
          } else {
            form?.classList.remove('disable-buy-button');
          }
        });
        buyObserver.observe(addToCartButton, { attributes: true });
      }

      // Product variant event listener for theme specific logic

      this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
      if ( this.productVariants ) {
        this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
        this.onVariantChangeHandler({ target: this.productVariants });
      }
    }

    thumbnailNavigationHelper(index = 0){
      this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
        if ( i == index ) {
          elm.classList.add('active');
        } else {
          elm.classList.remove('active');
        }
      });
    }

    onVariantChangeHandler(e){
      const variant = e.target.currentVariant;
      if ( variant && variant.featured_media != null ) {
        const variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
        if ( variantImg ) {
          if (
            this.productGallery.classList.contains('product-gallery--slider') ||
            ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 )
          ) {
            const slider = this.productGallery.querySelector('css-slider');
            if ( slider && slider.sliderEnabled ) {
              slider.changeSlide(variantImg.dataset.index);
            } else {
              this.firstProductGalleryIndex = variantImg.dataset.index;
            }
          } else {
            window.scrollTo({
              top: variantImg.offsetTop,
              behavior: 'smooth'
            });
          }
        }
      }
    }

  }

  if ( typeof customElements.get('product-page') === 'undefined' ) {
    customElements.define('product-page', ProductPage);
  }

}